import React__default, { useEffect } from 'react';
import { useSearchContext } from '../../searchContext/SearchContextProvider.js';

var connectTaxonomyRenderer = function connectTaxonomyRenderer(component, taxonomyId) {
  return function () {
    var _useSearchContext = useSearchContext(),
      registerTaxonomyRenderer = _useSearchContext.registerTaxonomyRenderer;
    useEffect(function () {
      return registerTaxonomyRenderer(component, taxonomyId);
    }, []);
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  };
};

export { connectTaxonomyRenderer };
//# sourceMappingURL=connectTaxonomyRenderer.js.map
